// feedbackQuestions.js

export const AlumniFeedbackQuestions = [
  {
    question: "I have become more knowledgeable now in my field of study",
    translation: "நான் இப்போது எனது படிப்புத் துறையில் அதிக திறமையாக உள்ளேன்",
    name: "knowledge_in_field",
  },
  {
    question: "I know the latest developments in my field and I’m up-to-date",
    translation: "எனது துறையில் சமீபத்திய முன்னேற்றங்கள் எனக்குத் தெரியும், நான் புதுப்பித்த நிலையில் இருக்கிறேன்",
    name: "latest_developments",
  },
  {
    question: "Nowadays, I’m more practical in solving issues related to my work/domain",
    translation: "எனது பணி/துறையில் தொடர்பான சிக்கல்களை தீர்ப்பதில் நான் மிகவும் நடைமுறையில் இருக்கிறேன்",
    name: "practical_solving",
  },
  {
    question: "My thoughts are more creative after the completion of my course",
    translation: "எனது படிப்பை முடித்த பிறகு எனது எண்ணங்கள் மிகவும் ஆக்கபூர்வமாக இருக்கின்றன",
    name: "creative_thoughts",
  },
  {
    question: "I’m more analytical in assessing situations nowadays",
    translation: "சூழ்நிலைகளைக் மதிப்பீடு செய்வதில் நான் மிகவும் பகுத்தறிவு கொண்டவனாக இருக்கிறேன்",
    name: "analytical_assessment",
  },
  {
    question: "I have become more of a self-learner recently",
    translation: "நான் சமீபகாலமாக சுயமாக கற்க மாறிவிட்டேன்",
    name: "self_learner",
  },
  {
    question: "I can relate the importance of financial management for my professional life",
    translation: "எனது வாழ்க்கைக்கான நிதி நிர்வாகத்தின் முக்கியத்துவத்தை என்னால் விவரிக்க முடியும்",
    name: "financial_management",
  },
  {
    question: "I know my capabilities",
    translation: "எனது திறன்களை நான் அறிவேன்",
    name: "know_capabilities",
  },
  {
    question: "I’m familiar with modern equipment/tools in the field",
    translation: "துறையில் உள்ள நவீன உபகரணங்கள்/கருவிகளை நான் நன்கு அறிந்திருக்கிறேன்",
    name: "modern_equipment",
  },
  {
    question: "I mingle better with my peer group",
    translation: "நான் எனது சக குழுவுடன் நன்றாக பழகுகிறேன்",
    name: "peer_interaction",
  },
  {
    question: "I have more professional friends",
    translation: "எனக்கு தொழில்முறை நண்பர்கள் அதிகம்",
    name: "professional_friends",
  },
  {
    question: "I’m talented to lead a group",
    translation: "நான் ஒரு குழுவை வழிநடத்த திறமையாக உள்ளேன்",
    name: "leadership_ability",
  },
  {
    question: "Over the years, I developed ability to communicate effectively",
    translation: "நான் திறம்பட தொடர்பு கொள்ளும் திறனை வளர்த்துக் கொண்டேன்",
    name: "effective_communication",
  },
  {
    question: "I can express my ideas clearly to others",
    translation: "எனது எண்ணங்களை மற்றவர்களுக்கு தெளிவாக வெளிப்படுத்த முடிகிறது",
    name: "clear_expression",
  },
  {
    question: "My actions are more ethical than before",
    translation: "எனது செயல்கள் முன்பை விட ஒழுக்கமானவையாக இருக்கிறது",
    name: "ethical_actions",
  },
  {
    question: "The College has given me the strong foundation for what I am today.",
    translation: "இன்று நான் இருக்கும் நிலைக்கு கல்லூரி எனக்கு வலுவான அடித்தளத்தை அளித்துள்ளது.",
    name: "strong_foundation",
  },
  {
    question: "The College had sufficient infrastructures when I studied over there.",
    translation: "நான் படிக்கும் போது கல்லூரியில் போதிய உள்கட்டமைப்பு இருந்தது.",
    name: "sufficient_infra",
  },
  {
    question: "The college provided me enough opportunities to do other co-curricular and extra-curricular activities.",
    translation: "இக்கல்லூரி எனக்கு மற்ற இணை பாடத்திட்டம் மற்றும் பாடநெறிக்கு அப்பாற்பட்ட செயல்களைச் செய்ய போதுமான வாய்ப்புகளை வழங்கியது.",
    name: "opportunities",
  },
  {
    question: "The teachers then were so knowledgeable and taught us well.",
    translation: "அப்போதைய ஆசிரியர்கள் மிகவும் அறிவாளிகள் மற்றும் எங்களுக்கு நன்றாக கற்பித்தார்கள்.",
    name: "knowledge_taught",
  },
  {
    question: "The teachers were so concerned on the students' future.",
    translation: "மாணவர்களின் எதிர்காலம் குறித்து ஆசிரியர்கள் மிகுந்த அக்கறையுடன் இருந்தனர்.",
    name: "students_future",
  },
 
];

// feedbackQuestions.js

export const CollegeFeedbackQuestions = [
  {
    question: "Rate your satisfaction level with the virtual classroom of the department.",
    translation: "துறையின் மெய்நிகர் வகுப்பறையுடன் உங்கள் திருப்தி நிலையை மதிப்பிடுங்கள்.",
    name: "virtual_classroom",
  },
  {
    question: "Rate your satisfaction level with the classroom of the department.",
    translation: "துறையின் வகுப்பறையுடன் உங்கள் திருப்தி நிலையை மதிப்பிடுங்கள்.",
    name: "classroom_satisfaction",
  },
  {
    question: "Rate your satisfaction level with the Laboratories in the department.",
    translation: "துறையில் உள்ள ஆய்வகங்களில் உங்கள் திருப்தி நிலையை மதிப்பிடுங்கள்.",
    name: "lab_satisfaction",
  },
  {
    question: "Rate your satisfaction level with the computers in the department.",
    translation: "துறையில் உள்ள கணினிகளில் உங்கள் திருப்தி நிலையை மதிப்பிடுங்கள்.",
    name: "computer_satisfaction",
  },
  {
    question: "Rate your satisfaction level with the Wi-Fi & Internet facilities in the college.",
    translation: "கல்லூரியில் உள்ள வைஃபை மற்றும் இணைய வசதிகள் மூலம் உங்கள் திருப்தி நிலையை மதிப்பிடுங்கள்.",
    name: "wifi_internet_satisfaction",
  },
  {
    question: "Rate your satisfaction level with the Library services of the college.",
    translation: "கல்லோரியின் நூலகச் சேவைகளில் உங்கள் திருப்தி நிலையை மதிப்பிடுங்கள்.",
    name: "library_services",
  },
  {
    question: "How does the Placement cell help in improving students’ skills?",
    translation: "மாணவர்களின் திறமையை மேம்படுத்த வேலை வாய்ப்பு செல் எவ்வாறு உதவுகிறது?",
    name: "placement_cell_help",
  },
  {
    question: "How satisfied are you with the Auditorium provided by the college?",
    translation: "கல்லூரி வழங்கிய ஆடிட்டோரியம் எவ்வளவு திருப்தியாக உள்ளது?",
    name: "auditorium_satisfaction",
  },
  {
    question: "How satisfied are you with the Generator provided by the college?",
    translation: "கல்லூரி வழங்கிய ஜெனரேட்டரில் நீங்கள் எவ்வளவு திருப்தி அடைகிறீர்கள்?",
    name: "generator_satisfaction",
  },
  {
    question: "Rate your satisfaction level with sports activities in the college.",
    translation: "கல்லூரியில் விளையாட்டு நடவடிக்கைகளில் உங்கள் திருப்தி நிலையை மதிப்பிடுங்கள்.",
    name: "sports_satisfaction",
  },
  {
    question: "How satisfied are you with the Post-office services in the college?",
    translation: "கல்லூரியில் தபால் அலுவலகச் சேவைகளில் எவ்வளவு திருப்திகரமாக உள்ளீர்கள்?",
    name: "post_office_satisfaction",
  },
  {
    question: "Rate your satisfaction level with the facility available in the college Dispensary.",
    translation: "கல்லூரி மருந்தகத்தில் உள்ள வசதியுடன் உங்கள் திருப்தி நிலையை மதிப்பிடுங்கள்.",
    name: "dispensary_satisfaction",
  },
  {
    question: "How satisfied are you with the cleanliness and variety of food items available in the canteen?",
    translation: "கேண்டீனில் கிடைக்கும் தூய்மை மற்றும் பல்வேறு வகையான உணவுப் பொருட்களில் நீங்கள் எவ்வளவு திருப்தி அடைகிறீர்கள்?",
    name: "canteen_food_satisfaction",
  },
  {
    question: "Rate your satisfaction level with the drinking water arrangement in the college.",
    translation: "கல்லோரியில் குடிநீர் ஏற்பாட்டின் மூலம் உங்கள் திருப்தியின் அளவை மதிப்பிடுங்கள்.",
    name: "drinking_water_satisfaction",
  },
  {
    question: "How satisfied are you with the hostel facility provided in the college?",
    translation: "கல்லோரியில் வழங்கப்படும் விடுதி வசதி எவ்வளவு திருப்திகரமாக உள்ளது?",
    name: "hostel_satisfaction",
  },
  {
    question: "How satisfied are you with the timing and facilities of the college bus?",
    translation: "கல்லோரி பேருந்தின் நேரம் மற்றும் வசதிகளில் நீங்கள் எவ்வளவு திருப்தி அடைகிறீர்கள்?",
    name: "college_bus_satisfaction",
  },
  {
    question: "Rate your satisfaction level with the toilet facility of the college.",
    translation: "கல்லோரியின் கழிப்பறை வசதியுடன் உங்கள் திருப்தி நிலையை மதிப்பிடுங்கள்.",
    name: "toilet_satisfaction",
  },
  {
    question: "Rate your satisfaction level with the cleanliness of the college campus.",
    translation: "கல்லோரி வளாகத்தின் தூய்மையுடன் உங்கள் திருப்தி நிலையை மதிப்பிடுங்கள்.",
    name: "campus_cleanliness_satisfaction",
  }
];



export const std_mini_project_fb_data=[
  {
    question:"Objectives of the project were well defined ",
    translation:"",
    name: "project_objectives"
  },
  {
    question:"Extent of technical support by the supervisor to complete the project",
    translation:"",
    name: "technical_support"
  },
  {
    question:"Extent of facilities offered or available in the department in perusing the project work",
    translation:"",
    name: "facilities_offered"
  },
  {
    question:"Project reviews or meetings were conducted regularly",
    translation:"",
    name: "frequency_0f_project_reviews"
  },
  {
    question:"Project reviews helped us to enhance the quality and quantity of work",
    translation:"",
    name: "helpful_of_project_reviews"
  },
  {
    question:"Support of supervisor in preparing and evaluating the thesis",
    translation:"",
    name: "support_of_suppervisor"
  },
  {
    question:"Did you implement the knowledge gained in developing the project?",
    translation:"",
    name: "implementation_of_knowledge"
  },
  {
    question:"Did the project work motivate you to do new findings even after completing the course?",
    translation:"",
    name: "motivation_to_do_new_findings"
  },
  {
    question:"The project developed is beneficial to the society",
    translation:"",
    name: "project_beniefit_to_society"
  },
  {
    question:"Whether appreciated and recognized as an individual or as a team for the work done",
    translation:"",
    name: "appreciation"
  },
];




  export const employerFeedbackQuestions = [
    {
      question: "Technical knowledge/skill",
      translation: "தொழில்நுட்ப அறிவு/திறன்",
      name: "technical_knowledge",
    },
    {
      question: "Communication skill",
      translation: "தொடர்பு திறன்",
      name: "communication_skill",
    },
    {
      question: "Independent thinking and problem solving ability",
      translation: "சுய‌ சிந்தனை மற்றும் சிக்கலை தீர்க்கும் திறன்",
      name: "independent_thinking",
    },
    {
      question: "Inclination to adopt new technology",
      translation: "புதிய தொழில்நுட்பத்தை கடைப்பிடிக்க விருப்பம்",
      name: "new_technology_inclination",
    },
    {
      question: "Ability to take up extra responsibility",
      translation: "கூடுதல் பொறுப்பை ஏற்கும் திறன்",
      name: "extra_responsibility",
    },
    {
      question: "Obligation to work beyond schedule if required",
      translation: "தேவைப்பட்டால் அட்டவணைக்கு அப்பால் வேலை செய்ய வேண்டிய கடமை",
      name: "work_beyond_schedule",
    },
    {
      question: "Ability to contribute to the goal of the organization",
      translation: "நிறுவனத்தின் இலக்குக்கு பங்களிக்கும் திறன்",
      name: "organizational_contribution",
    },
    {
      question: "Planning and organization skills",
      translation: "திட்டமிடல் மற்றும் ஒருங்கிணைக்கும் திறன்கள்",
      name: "planning_organization_skills",
    },
    {
      question: "Possess leadership qualities",
      translation: "தலைமை பண்புகளை கொண்டவர்",
      name: "leadership_qualities",
    },
    {
      question: "Relationship with seniors and subordinates",
      translation: "மூத்தவர் மற்றும் துணை அதிகாரிகளுடனான உறவு",
      name: "relationship_with_seniors",
    },
  ];

  

export const parentFeedbackQuestions = [
  {
    question: "Rate the infrastructure facilities of the institution",
    translation: "நிறுவனங்களின் உட்கட்டமைப்பு வசதிகளை மதிப்பிடவும்",
    name: "infrastructure_facilities",
    question: "Rate the infrastructure facilities of the institution",
    translation: "நிறுவனங்களின் உட்கட்டமைப்பு வசதிகளை மதிப்பிடவும்",
    name: "infrastructure_facilities",
  },
  {
    question: "Rate the ambience of the college with respect to the facilities such as ATM, post office, medical facilities, and transportation given to your ward",
    translation: "தன்னியக்க காசளிப்பு இயந்திரம் (ஏடிஎம்), தபால் அலுவலகம், மருத்துவ வசதிகள், போக்குவரத்து வசதிகளைப் பொருத்து கல்லூரி சூழலை மதிப்பிடவும்",
    name: "college_ambience",
    question: "Rate the ambience of the college with respect to the facilities such as ATM, post office, medical facilities, and transportation given to your ward",
    translation: "தன்னியக்க காசளிப்பு இயந்திரம் (ஏடிஎம்), தபால் அலுவலகம், மருத்துவ வசதிகள், போக்குவரத்து வசதிகளைப் பொருத்து கல்லூரி சூழலை மதிப்பிடவும்",
    name: "college_ambience",
  },
  {
    question: "Authorities and the college office are approachable, ready to help and clarify your queries",
    translation: "அதிகாரிகள் மற்றும் கல்லூரி அலுவலகம் அணுகக்கூடியது, உங்கள் கேள்விகளுக்கு உதவவும் தெளிவுப்படுத்தவும் தயாராக உள்ளது",
    name: "authority_approachability",
    question: "Authorities and the college office are approachable, ready to help and clarify your queries",
    translation: "அதிகாரிகள் மற்றும் கல்லூரி அலுவலகம் அணுகக்கூடியது, உங்கள் கேள்விகளுக்கு உதவவும் தெளிவுப்படுத்தவும் தயாராக உள்ளது",
    name: "authority_approachability",
  },
  {
    question: "Is your ward happy with the hostel facilities?",
    translation: "உங்கள் பிள்ளைகள் விடுதி வசதிகளால் மகிழ்ச்சியாக உள்ளனரா?",
    name: "hostel_facilities",
    question: "Is your ward happy with the hostel facilities?",
    translation: "உங்கள் பிள்ளைகள் விடுதி வசதிகளால் மகிழ்ச்சியாக உள்ளனரா?",
    name: "hostel_facilities",
  },
  {
    question: "Rate the library and sport facilities",
    translation: "நூலகம் மற்றும் விளையாட்டு வசதிகளை மதிப்பிடவும்",
    name: "library_sports_facilities",
    question: "Rate the library and sport facilities",
    translation: "நூலகம் மற்றும் விளையாட்டு வசதிகளை மதிப்பிடவும்",
    name: "library_sports_facilities",
  },
  {
    question: "What is your assessment of security and safety measures in the institution?",
    translation: "கல்வி நிறுவனத்தில் பாதுகாப்பு மற்றும் பாதுகாப்பு நடவடிக்கைகள் பற்றிய உங்கள் மதிப்பீடு என்ன?",
    name: "security_safety_measures",
    question: "What is your assessment of security and safety measures in the institution?",
    translation: "கல்வி நிறுவனத்தில் பாதுகாப்பு மற்றும் பாதுகாப்பு நடவடிக்கைகள் பற்றிய உங்கள் மதிப்பீடு என்ன?",
    name: "security_safety_measures",
  },
  {
    question: "Rate the academic skills and knowledge of the faculty",
    translation: "ஆசிரியர்களின் கல்வித்திறன் மற்றும் அறிவை மதிப்பிடுங்கள்",
    name: "faculty_academic_skills",
    question: "Rate the academic skills and knowledge of the faculty",
    translation: "ஆசிரியர்களின் கல்வித்திறன் மற்றும் அறிவை மதிப்பிடுங்கள்",
    name: "faculty_academic_skills",
  },
  {
    question: "Rate the learning experience of your ward in the institution",
    translation: "நிறுவனத்தில் உங்கள் பிள்ளைகளின் கற்றல் அனுபவத்தை மதிப்பிடவும்",
    name: "learning_experience",
    question: "Rate the learning experience of your ward in the institution",
    translation: "நிறுவனத்தில் உங்கள் பிள்ளைகளின் கற்றல் அனுபவத்தை மதிப்பிடவும்",
    name: "learning_experience",
  },
  {
    question: "Rate the environment in terms of diversity among the students in the institution",
    translation: "நிறுவனத்தில் உள்ள மாணவர்களிடையே பண்முகத்தன்மையின் அடிப்படையில் மதிப்பிடவும்",
    name: "environment_diversity",
    question: "Rate the environment in terms of diversity among the students in the institution",
    translation: "நிறுவனத்தில் உள்ள மாணவர்களிடையே பண்முகத்தன்மையின் அடிப்படையில் மதிப்பிடவும்",
    name: "environment_diversity",
  },
  {
    question: "Assessment about the placement and internship opportunities provided by the institution",
    translation: "நிறுவனம் வழங்கிய வேலைவாய்ப்பு பற்றிய மதிப்பீடு",
    name: "placement_opportunities",
    question: "Assessment about the placement and internship opportunities provided by the institution",
    translation: "நிறுவனம் வழங்கிய வேலைவாய்ப்பு பற்றிய மதிப்பீடு",
    name: "placement_opportunities",
  },
  {
    question: "Technical knowledge of your ward has improved after joining the institution",
    translation: "நிறுவனத்தில் சேர்ந்தபிறகு உங்கள் பிள்ளையின் தொழில்நுட்ப அறிவு மேம்பட்டுள்ளது",
    name: "technical_knowledge_improvement",
    question: "Technical knowledge of your ward has improved after joining the institution",
    translation: "நிறுவனத்தில் சேர்ந்தபிறகு உங்கள் பிள்ளையின் தொழில்நுட்ப அறிவு மேம்பட்டுள்ளது",
    name: "technical_knowledge_improvement",
  },
  {
    question: "How conducive do you think the college environment is for the overall development of your ward?",
    translation: "உங்கள் பிள்ளையின் ஒட்டுமொத்த வளர்ச்சிக்குக் கல்லூரிச் சூழல் எந்த அளவுக்கு உகந்தது என்று நினைக்கிறீர்கள்",
    name: "college_environment_development",
  },
];

export const collaboratorFeedbackQustions = [
  {
    question:"Main objectives of the proposal",
    translation:"நோக்கம்",
    name:"proposal_objective",
  },
  {
    question:"Review of the state-of-art in the field",
    translation:"துறையில் கலைநிலை ஆய்வு மதிப்பீடு",
    name:"state_of_art",
  },
  {
    question:"Detailed Methodology and Plan of Action",
    translation:"வழிமுறை மற்றும் செயல்திட்டம்",
    name:"methodology_and_action_plan",
  },
  {
    question:"Performance Milestones and Schedule",
    translation:"செயல்திறன் மைல்கல் மற்றும் அட்டவனை",
    name:"performance_milestone",
  },
  {
    question:"Deliverables",
    translation:"வழங்ககூடியவை",
    name:"deliverables",
  },
  {
    question:"Estimated Expenditure",
    translation:"மதிப்பிடப்பட்ட செலவு",
    name:"estimated_expenditure",
  },
  {
    question:"Appointment of Research Staff in time",
    translation:"சரியான நேரத்தில் ஆராய்ச்சி ஊழியர்களை நியமித்தல்",
    name:"appoinment_of_staffs",
  },
  {
    question:"Completion of Modules in time",
    translation:"தொகுதிகளை சரியான நேரத்தில் முடித்தல்",
    name:"completion_in_time",
  },
  {
    question:"Result achieved as expected",
    translation:"எதிர்பார்த்தபடி முடிவு அடையப்பட்டது",
    name:"expected_result",
  },
  {
    question:"Performance in periodical Reviews",
    translation:"காலமுறை மதிப்பாய்வில் செயல்திறன்",
    name:"review_performance",
  },
  // {
  //   question:"Deliverables",
  //   translation:"வழங்ககூடியவை",
  //   name:"deliverables",
  // },
  // {
  //   question:"Estimated Expenditure",
  //   translation:"மதிப்பிடப்பட்ட செலவு",
  //   name:"estimated_expenditure",
  // },
  // {
  //   question:"Appointment of Research Staff in time",
  //   translation:"சரியான நேரத்தில் ஆராய்ச்சி ஊழியர்களை நியமித்தல்",
  //   name:"appoinment_of_staffs",
  // },
  // {
  //   question:"Completion of Modules in time",
  //   translation:"தொகுதிகளை சரியான நேரத்தில் முடித்தல்",
  //   name:"completion_in_time",
  // },
  // {
  //   question:"Result achieved as expected",
  //   translation:"எதிர்பார்த்தபடி முடிவு அடையப்பட்டது",
  //   name:"expected_result",
  // },
  // {
  //   question:"Performance in periodical Reviews",
  //   translation:"காலமுறை மதிப்பாய்வில் செயல்திறன்",
  //   name:"review_performance",
  // },
  {
    question:"Timely closure of the project",
    translation:"திட்டத்தைச் சரியான நேரத்தில் முடிப்பது",
    name:"project_closure_time",
  },
  {
    question:"Literature Collected",
    translation:"சேகரிக்கப்பட்ட ஆவணங்கள்",
    name:"literature_collected",
  },
  {
    question:"Final Technical Report(s)",
    translation:"இறுதி தொழில்நுட்ப அறிக்கை",
    name:"final_technical_report",
  },
  {
    question:"Hardware or Software developed",
    translation:"மென்பொருள் மற்றும் வன்பொருள்",
    name:"developed_hardware_or_software",
  },
  {
    question:"Deliverables as in Proposal",
    translation:"முன்மொழிவில் உள்ளபடி வழங்ககூடியவை",
    name:"proposal_deliverables",
  },
  {
    question:"Publications",
    translation:"வெளியீடு",
    name:"publications",
  },
  {
    question:"Patents",
    translation:"காப்புரிமை",
    name:"patents",
  },
];




export const supplierFeedbackQuestions = [
  {
    question: "Procurement process",
    translation: "கொள்முதல் செயல்முறை",
    name: "procurement_process",
  },
  {
    question: "Payment process",
    translation: "கட்டண செயல்முறை",
    name: "payment_process",
  },
  {
    question: "Staff members’ professionalism",
    translation: "ஊழியகர்களின் தொழில்முறை",
    name: "staff_professionalism",
  },
  {
    question: "Supplier's receipt process",
    translation: "சப்ளையர் ரசீது செயல்முறை",
    name: "receipt_process",
  },
  {
    question: "Paper work process",
    translation: "காகிதவேலை செயல்முறை",
    name: "paperwork_process",
  },
  {
    question: "Ability to provide efficient and effective communication at all levels",
    translation: "அனைத்து நிலைகளில் திறமையான மற்றும் பயனுள்ள தகவல்தொடர்புகளை வழங்குவதர்கான இருப்பு",
    name: "communication_efficiency",
  },
  {
    question: "Levels of ethical practice and support",
    translation: "நெறிமுறை,நடைமுறை மற்றும் ஆதரவு நிலைகள்",
    name: "ethical_practices",
  },
  {
    question: "Business relationship with you",
    translation: "வணிக உறவு",
    name: "business_relationship",
  },
];

export const consultancyFeedbackQuestions = [
  {
    question:"Consultancy Fee     ",
    translation:" நிறுவன கட்டணம் ",
    name:"consultancy_fee",
  },
  {
    question:"Meeting Deadline  ",
    translation:"காலக்கெடு",
    name:"meeting_deadline",
  },
  {
    question:"Work Quality",
    translation:"வேலை தரம்",
    name:"work_quality",
  },
  {
    question:"Approach",
    translation:"அணுகுமுறை",
    name:"approach",
  },
];



  export const std_teach_fb_data=[
    
      {
        question: "I carry the knowledge in Mathematics, Science, and Engineering fundamentals",
        translation: "",
        name: "knowledge_in_fundamentals"
      },
      {
        question: "I am able to analyze complex engineering problems",
        translation: "",
        name: "analyze_engineering_problems"
      },
      {
        question: "I am able to identify components, design systems, and reach solutions for engineering problems",
        translation: "",
        name: "identify_design_solutions"
      },
      {
        question: "I am able to do analysis and interpret the data to provide valid conclusions",
        translation: "",
        name: "data_analysis_interpretation"
      },
      {
        question: "I am able to use modern tools for engineering activities",
        translation: "",
        name: "use_modern_tools"
      },
      {
        question: "I am applying the contextual knowledge to assess several issues and the consequent responsibilities relevant to the profession",
        translation: "",
        name: "contextual_knowledge"
      },
      
        {
          question: "I understand the importance of engineering solutions for the development of society and the environment",
          translation: "",
          name: "importance_of_solutions"
        },
        {
          question: "I apply ethical principles and commit to professional ethics and responsibilities",
          translation: "",
          name: "ethical_principles"
        },
        {
          question: "I am able to function effectively as an individual, and as a member or as a leader in diverse teams",
          translation: "",
          name: "teamwork_ability"
        },
        {
          question: "I am able to communicate effectively (write reports, make effective presentations and give, receive clear instructions) with society at large",
          translation: "",
          name: "communication_effectiveness"
        },
        {
          question: "I am able to apply the knowledge related to Project management and finance",
          translation: "",
          name: "project_management_finance"
        },
        {
          question: "I am able to learn new techniques and update myself in the broadest context of technological change",
          translation: "",
          name: "learn_new_techniques"
        },
        {
          question: "I am able to analyze, design, and provide solutions to the problems pertaining to Electronics, VLSI, Image processing, and Embedded systems",
          translation: "",
          name: "analyze_design_solutions_electronics"
        },
        {
          question: "I am able to analyze, design, and provide solutions to the problems pertaining to RF and Microwaves, Wireless and Optical Communication",
          translation: "",
          name: "analyze_design_solutions_rf_microwaves"
        },
        {
          question: "I am able to design web-based and mobile-based applications",
          translation: "",
          name: "design_web_mobile_apps"
        },
      
  ]
    export const practical_fb_data=[
      {
        question: "Lab manuals are supplied at the beginning of the lab",
        translation: "",
        name: "lab_manual_supply"
      },
      {
        question: "Labs were neat and clean with proper labelling and marking of equipment’s ",
        translation: "",
        name: "clean_and_neatness_of_lab"
      },
      {
        question: "All equipment’s were in working condition",
        translation: "",
        name: "equipment_working_condition"
      },
      {
        question: "Each student gets a chance to perform the experiment by his/her own  hands",
        translation: "",
        name: "student_performance_on_own_hand"
      },
      {
        question: "Lab hours were mostly spent on performing experiments",
        translation: "",
        name: "lab_hours_for_experiment"
      },
      {
        question: "Faculty was cooperative and ensured the smooth conduct of the experiments",
        translation: "",
        name: "faculty_cooperation"
      },
      {
        question: "Faculty had in-depth knowledge about the experiments",
        translation: "",
        name: "faculty_knowledge"
      },
      {
        question: "Lab reports were checked timely with proper marking or grading",
        translation: "",
        name: "lab_reports_checking"
      },
      {
        question: "Model exams were conducted and helped us to prepare for semester exams",
        translation: "",
        name: "conducting_model_exams"
      },
      {
        question: "Practical sessional exams were held in time",
        translation: "",
        name: "on_time_of_practical_exams"
      },
      {
        question: "Experiments helped in better understanding of the subject",
        translation: "",
        name: "helpful_of_experiments"
      },
    ];
    
 
    export const technical_fb_data=[
      {
        question: "Faculty detailed the objectives and the plan of execution of the course to the students ",
        translation: "",
        name: "faculty_objectives_plan"
      },
      {
        question: "Faculty gave advise in selection and presentation of topics",
        translation: "",
        name: "faculty_advice_topics"
      },
      {
        question: "Effectiveness of Faculty in making the students use modern presentation aids",
        translation: "",
        name: "effectiveness_modern_aids"
      },
      {
        question: "Faculty support towards the development of students skill",
        translation: "",
        name: "faculty_support_skills"
      },
      {
        question: "Faculty made the seminar class a positive learning environment",
        translation: "",
        name: "seminar_class_environment"
      },
      {
        question: "Faculty and the course motivated the students do their best work",
        translation: "",
        name: "motivation_to_do_best"
      },
      {
        question: "Faculty appreciated the students ideas and presentation",
        translation: "",
        name: "appreciation_of_ideas"
      },
      {
        question: "Faculty appeared enthusiastic and interested",
        translation: "",
        name: "enthusiasm_interest"
      },
      {
        question: "Faculty was accessible outside of class",
        translation: "",
        name: "faculty_accessibility"
      },
      {
        question: "I found the course to be interesting and a platform to learn and present new ideas",
        translation: "",
        name: "course_interest_platform"
      },
    ]


  export const student_fb_card=[
    {
      'id':'1',
      'program':'Teaching and Learning ',
      'pdf':'./Std_teaching_fb'
    },
    {
      'id':'2',
      'program':'Practical and Laboratory Feedback',
      'pdf':'./Practical_fb'
    },
    {
      'id':'3',
      'program':'Technical Seminar Feedback',
      'pdf':'Technical_fb'
    },
    {
      'id':'4',
      'program':'Mini Project and Project Feedback',
      'pdf':'./Std_mini_project_fb'
    },
    {
      'id':'5',
      'program':'Student Satisfaction on Teaching Learning',
      'pdf':'./std_statisf'
    },
    {
      'id':'6',
      'program':'Student Satisfaction on Facilities',
      'pdf':'./std_fac'
    },
   
  ]



  